import { LogrocketTracker } from '@audibene/ta-browser-tracker'
import pkg from '../../../package.json'
import { config } from '../../config'
import { Environment } from '../../constants'
import { logFactory } from '../../util'

const { APP_ENV: ENVIRONMENT, LOGROCKET_PROJECT_ID } = config
const log = logFactory('startup:logRocket')
const logRocket = new LogrocketTracker({ appVersion: pkg.version, id: LOGROCKET_PROJECT_ID })

const init = () => {
  const liveEnvironments = [Environment.DEVELOPMENT, Environment.PRODUCTION, Environment.STAGING, Environment.TESTING]
  const isLiveEnvironment = liveEnvironments.includes(ENVIRONMENT as Environment) && Boolean(LOGROCKET_PROJECT_ID)

  if (isLiveEnvironment) {
    log('🚀 LogRocket initializing...', LOGROCKET_PROJECT_ID)
    logRocket.init()
    log('🚀 LogRocket initialized')
  }
}

export { logRocket, init }
